import { Badge } from '@mantine/core';

export function SupportCaseStatusBadge({ status }: { status: string }) {
  const color = () => {
    if (status === 'New') return 'blue';
    if (status === 'Response Needed') return 'red';
    if (status === 'Closed') return 'green';
    if (status === 'Reopened') return 'red';
    return 'orange';
  };
  return (
    <Badge variant="light" color={color()}>
      {status}
    </Badge>
  );
}
